import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportsServicesService {
  url = environment.apiUrl;
  constructor(private http:HttpClient) { 

  }

  getStataments(clientId:number,fromDate:Date,toDate:Date):Observable<any>{
    return this.http.get(this.url+'reports/statement?clientId='+clientId+"&fromDate="+fromDate.toISOString()+"&toDate="+toDate.toISOString());
  }

  getConsumptions(clientId:number,fromDate:Date,toDate:Date,fromCard:number,toCard:number,page:number,numRows:number,stationNumber:number,redcoData:number,folioFactura:number):Observable<any>{
    
    return this.http.get(this.url+'reports/consumptions?clientId='+clientId+"&fromDate="+fromDate.toISOString()+"&toDate="+toDate.toISOString()+"&fromCard="+fromCard+"&toCard="+toCard+"&page="+page+"&numRows="+numRows+"&stationNumber="+stationNumber+"&redcoData="+redcoData+"&factura="+folioFactura);
  }

  getConsumptionsChart(clientId:number,fromDate:Date,toDate:Date,fromCard:number,toCard:number):Observable<any>{
    return this.http.get(this.url+'reports/consumptions/chart/monthly?clientId='+clientId+"&fromDate="+fromDate.toISOString()+"&toDate="+toDate.toISOString()+"&fromCard="+fromCard+"&toCard="+toCard);
  }

  getLogs(clientId:number,fromDate:Date,toDate:Date,card:number,searchBy:number):Observable<any>{
    return this.http.get(this.url+'reports/logs?clientId='+clientId+"&fromDate="+fromDate.toISOString()+"&toDate="+toDate.toISOString()+"&card="+card+"&searchby="+searchBy);
  }

  getStations(zoneId:number|null):Observable<any>{
    let queryString ="";
    if(zoneId){
      queryString+="&zoneId="+zoneId!;
    }
    return this.http.get(this.url+'station'+queryString);
  }
  getConsumptionSignature(clientId:number,secuence:number):Observable<any>{
    
    return this.http.get(this.url+'consumption/signature?clientId='+clientId+'&secuence='+secuence);
  }

  getConsumptionPhotos(clientNumber:number,secuence:number):Observable<any>{
    
    return this.http.get(this.url+'consumption/photos?clientNumber='+clientNumber+'&secuence='+secuence);
  }

  getBalance(clientNumber:number,month:number,year:number):Observable<any>{
    return this.http.get(this.url+'reports/balance?clientNumber='+clientNumber+'&month='+month+'&year='+year);
  }

  getComissionInvoice(client:number,fromDate:Date,toDate:Date):Observable<any>{
    return this.http.get(this.url+'reports/comission/invoice?clientNumber='+client+"&fromDate="+fromDate.toISOString()+"&toDate="+toDate.toISOString());
  }

  getQRsClient(client:number,fromDate:Date,toDate:Date,card:number){
    return this.http.get(this.url+'qr?clientNumber='+client+"&fromDate="+fromDate.toISOString()+"&toDate="+toDate.toISOString()+"&card="+card);
  }
}
